module.exports = __webpack_public_path__ + "static/media/orange-star.dd674560.svg";